<template>
	<div>
		<div v-for="(field, key) in fieldProps"
		     :key="key">
			<form-field-wrap
					v-if="field.TYPE == 'password'"
					:field-props="field"
					:is-error="errorPass"
					:field-value="inputValuePass"
					:input-focus="inputFocusPass"
					:is-switch="isSwitch"
			>
				<input class="form-field__input"
				       :class="inputClass"
				       ref="password"
				       type="password"
				       autocomplete="off"
				       v-validate="rulesPass"
				       :data-vv-as="field.TITLE"
				       :name="field.CODE"
				       :id="field.ID"
				       :value="inputValuePass"
				       @input="changeValuePass"
				       @focus="labelSwitchPass('focus')"
				       @blur="labelSwitchPass">
				<div class="form-field__desc">
					<slot name="desc"></slot>
				</div>
			</form-field-wrap>
			<form-field-wrap
					v-else
					:field-props="field"
					:is-error="errorConfirmPass"
					:field-value="inputValueConfirmPass"
					:input-focus="inputFocusConfirmPass || inputFocusPass"
					:is-switch="isSwitch"
			>
				<input class="form-field__input"
				       :class="inputClass"
				       type="password"
				       autocomplete="off"
				       v-validate="rulesConfirmPass"
				       :data-vv-as="field.TITLE"
				       :name="field.CODE"
				       :id="field.ID"
				       :value="inputValueConfirmPass"
				       @input="changeValueConfirmPass"
				       @focus="labelSwitchConfirmPass('focus')"
				       @blur="labelSwitchConfirmPass">
			</form-field-wrap>
		</div>
	</div>
</template>
<script>
	export default {
		name: "FormFieldPasswordConfirm",
		props: {
			fieldProps: {
				type: [Object, Array],
				default: function () {
					return {}
				}
			},
			isSwitch: {
				type: Boolean,
				default: false
			},
			inputClass: {
				type: String,
				default: ''
			}
		},
		data: function () {
			return {
				inputValuePass: '',
				inputFocusPass: '',
				rulesPass: '',
				inputValueConfirmPass: '',
				inputFocusConfirmPass: '',
				rulesConfirmPass: '',
			}
		},
		created: function () {
			for (let key in this.fieldProps) {
				let arRules = [];

				if (this.fieldProps[key].REQUIRED == "Y") {
					arRules.push('required');
				}
				if (this.fieldProps[key].RULES) {
					arRules = arRules.concat(this.fieldProps[key].RULES);
				}

				if (this.fieldProps[key].CODE == 'password') {
					this.rulesPass = arRules.join('|');
					this.inputValuePass = this.fieldProps[key].VALUE;
					this.inputFocusPass = false;
				} else {
					this.rulesConfirmPass = arRules.join('|');
					this.inputValueConfirmPass = this.fieldProps[key].VALUE;
					this.inputFocusConfirmPass = false;
				}
			}
		},
		watch: {
			value(newValue, oldValue) {
				this.inputValue = newValue;
			},
			error() {
				this.$emit('is-error', {
					error: this.error
				});
			}
		},
		computed: {
			errorPass() {
				for (let key in this.fieldProps) {
					if (this.fieldProps[key].CODE == 'password') {
						return this.errors.first(this.fieldProps[key].CODE);
					}
				}
			},
			errorConfirmPass() {
				for (let key in this.fieldProps) {
					if (this.fieldProps[key].CODE == 'passwordConfirm') {
						return this.errors.first(this.fieldProps[key].CODE);
					}
				}
			},
		},
		methods: {
			changeValuePass: function ($event) {
				this.inputValuePass = $event.target.value;
				for (let key in this.fieldProps) {
					if (this.fieldProps[key].CODE == "password") {
						this.fieldProps[key].VALUE = this.inputValuePass;
					}
				}
			},
			changeValueConfirmPass: function ($event) {
				this.inputValueConfirmPass = $event.target.value;
				for (let key in this.fieldProps) {
					if (this.fieldProps[key].CODE == "passwordConfirm") {
						this.fieldProps[key].VALUE = this.inputValueConfirmPass;
					}
				}
			},
			labelSwitchPass(active) {
				if (active == 'focus') {
					this.inputFocusPass = true;
				} else {
					this.inputFocusPass = false;
				}
			},
			labelSwitchConfirmPass(active) {
				if (active == 'focus') {
					this.inputFocusConfirmPass = true;
				} else {
					this.inputFocusConfirmPass = false;
				}
			},
			async checkValid() {
				let validate = this.$validator.validate().then(result => {
					if (result) {
						return true;
					} else {
						return false;
					}
				}).catch(() => {
					return false;
				});

				let result = await validate;
				return result;
			},
			resetValid: async function () {
				this.$validator.reset();
			},
		},
	};
</script>